/** Resolve a backend path against the configured origin, requiring same-origin Access cookies. */
export function resolveBackendUrl(path) {
    const configuredOrigin = window.__DF_BUCKET_LOCATOR_CONFIG__?.backendOrigin;
    const backendUrl = new URL(configuredOrigin || window.location.origin, window.location.origin);
    if (backendUrl.origin !== window.location.origin) {
        throw new Error(`Bucket Locator requires its backend to share the page origin (${window.location.origin}); received ${backendUrl.origin}`);
    }
    return new URL(path, `${backendUrl.origin}/`).toString();
}
//# sourceMappingURL=backend-url.js.map